/**
 * Google Pay environment resolution — which Google Pay environment signs the
 * token: DEV builds use TEST, BETA/PROD use PRODUCTION.
 *
 * The environment MUST match the gateway the token is redeemed against. BETA
 * signs under PRODUCTION because beta already transacts against the PRODUCTION
 * Till gateway (`gateway.tillpayments.com`, .env.*.beta.yml) with the production
 * Apple Pay merchant — a TEST-signed token is a dummy that gateway cannot
 * charge, so BETA under TEST fails every real card. DEV is the only true test
 * stack (test-gateway.tillpayments.com + sandbox Apple merchant). Keep this
 * mapping aligned with TILL_GATEWAY if the beta stack ever moves.
 *
 * Merchant identity is MFL-driven on every surface and every ENV (merchant_id,
 * merchant_origin, auth_jwt, software_info forwarded verbatim from
 * /me/payment-services/{id}/tokenization). PRODUCTION additionally requires that
 * identity to be Google-approved: a real Business Console merchant_id, and for
 * web a verified merchant_origin.
 *
 * Scope caveat: this value reliably drives the PAYMENT SHEET (web
 * PaymentsClient + Android show()). The Android AVAILABILITY probe ignores it —
 * the pinned lib's PaymentsModule.java hardcodes ENVIRONMENT_TEST inside
 * canMakePayments() and never parses an environment from methodData. The
 * Android probe is therefore a device/wallet CAPABILITY check only; the
 * PRODUCTION sheet at payment time is the authoritative validator.
 */
import config from '../../../../../config';

export function resolveGooglePayEnvironment(): 'TEST' | 'PRODUCTION' {
  return config.ENV !== 'DEV' ? 'PRODUCTION' : 'TEST';
}
